import { useAppState } from "AppState";
import React, { useContext } from "react";
import { Routes } from "router";

import { TabletDataContext } from "components/Gates/TabletDataGate";
import { shouldHideUsageType } from "components/UsageTypeSelector/utils";

import OnboardingContainer from "screens/Onboarding/Onboarding.container";
import TermsAndConditions from "screens/Onboarding/WelcomeBoard/TermsAndConditions/TermsAndConditions";
import TermsAndConditionsVerde from "screens/Onboarding/WelcomeBoard/TermsAndConditions/TermsAndConditionsVerde";
import useReactRouter from "use-react-router";

export default (): JSX.Element => {
  const {
    locationName,
    availableInterests,
    tenantId,
    verdeTenantIds
  } = useAppState();
  const { history } = useReactRouter();
  const tabletData = useContext(TabletDataContext);
  const { logoutCustomer } = OnboardingContainer.useContainer();

  const goToSignUpUsageTypeSelection = () =>
    history.push(Routes.SignUpUsageTypeSelection);

  const goToSignUpInterestSelection = () =>
    history.push(Routes.SignUpInterestSelection);
  const goToSignUpCustomerPersonalInfo = () =>
    history.push(Routes.SignUpCustomerPersonalInfo);

  const goToSignUp = () => {
    logoutCustomer();
    history.push(Routes.Home);
  };

  const toc = (
    <TermsAndConditions
      locationName={locationName}
      nextStep={
        shouldHideUsageType(tabletData)
          ? tabletData && tabletData.hasNoInterests
            ? goToSignUpCustomerPersonalInfo
            : goToSignUpInterestSelection
          : goToSignUpUsageTypeSelection
      }
      previousStep={goToSignUp}
    />
  );

  const tocVerde = (
    <TermsAndConditionsVerde
      tenantId={tenantId}
      locationName={locationName}
      nextStep={
        shouldHideUsageType(tabletData)
          ? tabletData && tabletData.hasNoInterests
            ? goToSignUpCustomerPersonalInfo
            : goToSignUpInterestSelection
          : goToSignUpUsageTypeSelection
      }
      previousStep={goToSignUp}
    />
  );

  const tocToServe = verdeTenantIds.includes(tenantId) ? tocVerde : toc;

  return tocToServe;
};



// WEBPACK FOOTER //
// ./src/screens/Onboarding/SignUp/TcpaAcknowledgement/TcpaAcknowledgement.tsx